export default __webpack_public_path__ + "static/media/Shelley_9781408347270.cfe3163c.jpg";